import { render, staticRenderFns } from "./Co43Page.vue?vue&type=template&id=38c93e7e"
import script from "./Co43Page.vue?vue&type=script&lang=js"
export * from "./Co43Page.vue?vue&type=script&lang=js"
import style0 from "./Co43Page.vue?vue&type=style&index=0&id=38c93e7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports